import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product } from 'src/app/models/core/product.model';

@Component({
  selector: 'app-venta-rapida-product-card',
  templateUrl: './venta-rapida-product-card.component.html',
  styleUrls: ['./venta-rapida-product-card.component.scss'],
  standalone: false
})
export class VentaRapidaProductCardComponent {
  @Input({ required: true }) product!: Product;
  @Output() selected = new EventEmitter<Product>();

  get priceDisplay(): string {
    const p = this.product.price;
    if (p === undefined || p === null) return '$0';
    return `$${p.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  }

  onClick(): void {
    this.selected.emit(this.product);
  }
}
